import StickyBar from './StickyBar';

export default StickyBar;